var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditSmallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26135_6115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 2.66699H2.66671C2.31309 2.66699 1.97395 2.80747 1.7239 3.05752C1.47385 3.30756 1.33337 3.6467 1.33337 4.00033V13.3337C1.33337 13.6873 1.47385 14.0264 1.7239 14.2765C1.97395 14.5265 2.31309 14.667 2.66671 14.667H12C12.3537 14.667 12.6928 14.5265 12.9428 14.2765C13.1929 14.0264 13.3334 13.6873 13.3334 13.3337V8.66699",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.66714C12.5986 1.40193 12.9583 1.25293 13.3334 1.25293C13.7084 1.25293 14.0682 1.40193 14.3334 1.66714C14.5986 1.93236 14.7476 2.29207 14.7476 2.66714C14.7476 3.04222 14.5986 3.40193 14.3334 3.66714L8.00004 10.0005L5.33337 10.6671L6.00004 8.00048L12.3334 1.66714Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26135_6115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmallIcon);
export default __webpack_public_path__ + "static/media/edit-small-icon.dc19fc9e.svg";
export { ForwardRef as ReactComponent };